
import { buildModelArray } from "@/common/utils/misc";

const MAX_NUMBER_OF_LETTERS = 15;
const MIN_NUMBER_OF_LETTERS = 3;
const DEFAULT_NUMBER_OF_LETTERS = 5;

export default {
	name: "CrosswordSolverForm",
	data() {
		return {
			numberOfLetters: DEFAULT_NUMBER_OF_LETTERS,
			defaultNumberOfLetters: DEFAULT_NUMBER_OF_LETTERS,
			min: MIN_NUMBER_OF_LETTERS,
			max: MAX_NUMBER_OF_LETTERS,
			localMultiInputValue: buildModelArray(DEFAULT_NUMBER_OF_LETTERS),
		};
	},

	computed: {
		_numberOfLetters: {
			get() {
				return this.numberOfLetters;
			},
			set(val) {
				if (!val.toString()) {
					return;
				}

				this.numberOfLetters = val;
			},
		},
		multiInputValue: {
			get() {
				return buildModelArray(this.numberOfLetters, [
					...this.localMultiInputValue,
				]);
			},
			set(val) {
				this.localMultiInputValue = buildModelArray(
					this.numberOfLetters,
					[...val]
				);
			},
		},
		isDisabled() {
			return this.localMultiInputValue.join("").trim().length === 0;
		},
	},
	methods: {
		onFormSubmit() {
			const params = {
				word_length: this.numberOfLetters,
				contains: this.localMultiInputValue
					.map((e) => e || "_")
					.join(""),
			};

			this.$emit("submit", params);
		},
	},
};
